import React, { useEffect, useState, useCallback } from "react";

import { Grid } from "@material-ui/core";
import { withFirebase } from "../Firebase";
import AddCompanyDialog from "./AddCompany";
import DeleteCompany from "./DeleteModal";
import EditCompanyDialog from "./EditCompany";
import { useError } from "../ErrorProvider";
import Table from "../StyledComponents/MaterialTable";
import { PageHeader, TableSkeleton } from "../UI";

const AdminCompanies = withFirebase(({ firebase }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showError } = useError();

  const handleDeleteCompany = (companyCode) => {
    setLoading(true);
    firebase
      .cleanupCompany({ companyCode })
      .then(() => fetchData())
      .catch((err) => showError(JSON.stringify(err)));
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let data = await firebase.companies().get();
      setCompanies(
        data.docs.map((companyDoc) => ({
          ...companyDoc.data(),
          id: companyDoc.id,
        }))
      );
    } catch (err) {
      showError(`Error loading companies: ${err}`);
    } finally {
      setLoading(false);
    }
  }, [firebase, showError]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const cols = [
    {
      title: "Actions",
      field: "",
      sorting: false,
      width: 80,
      render: (rowData) => (
        <>
          <EditCompanyDialog company={rowData} onSuccess={fetchData} />
          <DeleteCompany
            companyCode={rowData.id}
            callback={() => handleDeleteCompany(rowData.id)}
          />
        </>
      ),
    },
    {
      title: "Name",
      field: "CompanyName",
      defaultSort: "asc",
    },
    {
      title: "HR Email",
      field: "ContactEmail",
      render: (rowData) =>
        Array.isArray(rowData.ContactEmail)
          ? rowData.ContactEmail.join(", ")
          : rowData.ContactEmail,
    },
    {
      title: "Company Code",
      field: "id",
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader
          title="Companies"
          action={<AddCompanyDialog onSuccess={fetchData} />}
        />
      </Grid>
      <Grid item xs={12}>
        {loading ? (
          <TableSkeleton rows={8} />
        ) : (
          <Table
            columns={cols}
            data={companies}
            localization={{
              body: {
                emptyDataSourceMessage:
                  "No companies yet — add one to get started.",
              },
            }}
          />
        )}
      </Grid>
    </Grid>
  );
});

export default AdminCompanies;
